function debounce(fn, wait) {
  let t;
  return (...args) => {
    clearTimeout(t);
    t = setTimeout(() => fn.apply(this, args), wait);
  };
}
var dispatchCustomEvent = function dispatchCustomEvent(eventName) {
  var data = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
  var detail = {
    detail: data
  };
  var event = new CustomEvent(eventName, data ? detail : null);
  document.dispatchEvent(event);
};
window.recentlyViewedIds = [];

/**
 *  @class
 *  @function Quantity
 */
if (!customElements.get('quantity-selector')) {
  class QuantityInput extends HTMLElement {
    constructor() {
      super();
      this.input = this.querySelector('.qty');
      this.step = this.input.getAttribute('step');
      this.changeEvent = new Event('change', {
        bubbles: true
      });
      // Create buttons
      this.subtract = this.querySelector('.minus');
      this.add = this.querySelector('.plus');

      // Add functionality to buttons
      this.subtract.addEventListener('click', () => this.change_quantity(-1 * this.step));
      this.add.addEventListener('click', () => this.change_quantity(1 * this.step));

    }
    connectedCallback() {
      this.classList.add('buttons_added');
      this.validateQtyRules();
    }
    change_quantity(change) {
      // Get current value
      let quantity = Number(this.input.value);

      // Ensure quantity is a valid number
      if (isNaN(quantity)) quantity = 1;

      // Check for min & max
      if (this.input.getAttribute('min') > (quantity + change)) {
        return;
      }
      if (this.input.getAttribute('max')) {
        if (this.input.getAttribute('max') < (quantity + change)) {
          return;
        }
      }
      // Change quantity
      quantity += change;

      // Ensure quantity is always a number
      quantity = Math.max(quantity, 1);

      // Output number
      this.input.value = quantity;

      this.input.dispatchEvent(this.changeEvent);

      this.validateQtyRules();
    }
    validateQtyRules() {
      const value = parseInt(this.input.value);
      if (this.input.min) {
        const min = parseInt(this.input.min);
        this.subtract.classList.toggle('disabled', value <= min);
      }
      if (this.input.max) {
        const max = parseInt(this.input.max);
        this.add.classList.toggle('disabled', value >= max);
      }
    }
  }
  customElements.define('quantity-selector', QuantityInput);
}

/**
 *  @class
 *  @function ArrowSubMenu
 */
class ArrowSubMenu {

  constructor(self) {
    this.submenu = self.parentNode.querySelector('.sub-menu');
    this.arrow = self;
    // Add functionality to buttons
    self.addEventListener('click', (e) => this.toggle_submenu(e));
  }

  toggle_submenu(e) {
    e.preventDefault();
    let submenu = this.submenu;

    if (!submenu.classList.contains('active')) {
      submenu.classList.add('active');

    } else {
      submenu.classList.remove('active');
      this.arrow.blur();
    }
  }
}
let arrows = document.querySelectorAll('.thb-arrow');
arrows.forEach((arrow) => {
  new ArrowSubMenu(arrow);
});

/**
 *  @class
 *  @function ProductCard
 */
if (!customElements.get('product-card')) {
  class ProductCard extends HTMLElement {
    constructor() {
      super();
      this.swatches = this.querySelector('.product-card-swatches');
      this.image = this.querySelector('.product-card--featured-image-link .product-primary-image');
      this.additional_images = this.querySelectorAll('.product-secondary-image');
      this.additional_images_nav = this.querySelectorAll('.product-secondary-images-nav li');
      this.quick_add = this.querySelector('.product-card--add-to-cart-button-simple');
      this.size_options = this.querySelector('.product-card-sizes');
    }
    connectedCallback() {
      if (this.swatches) {
        this.enableSwatches(this.swatches, this.image);
      }
      if (this.additional_images) {
        this.enableAdditionalImages();
      }
      if (this.quick_add) {
        this.enableQuickAdd();
      }
      if (this.size_options) {
        this.enableSizeOptions();
      }
    }
    enableAdditionalImages() {
      let image_length = this.additional_images.length;
      let images = this.additional_images;
      let nav = this.additional_images_nav;
      let image_container = this.querySelector('.product-card--featured-image-link');
      const mousemove = function (e) {
        let l = e.offsetX;
        let w = this.getBoundingClientRect().width;
        let prc = l / w;
        let sel = Math.floor(prc * image_length);
        let selimg = images[sel];
        images.forEach((image, index) => {
          if (image.classList.contains('hover')) {
            image.classList.remove('hover');
            if (nav.length) {
              nav[index].classList.remove('active');
            }
          }
        });
        if (selimg) {
          if (!selimg.classList.contains('hover')) {
            selimg.classList.add('hover');
            if (nav.length) {
              nav[sel].classList.add('active');
            }
          }
        }

      };
      const mouseleave = function (e) {
        images.forEach((image, index) => {
          image.classList.remove('hover');
          if (nav.length) {
            nav[index].classList.remove('active');
          }
        });
      };
      if (image_container) {
        image_container.addEventListener('touchstart', mousemove, {
          passive: true
        });
        image_container.addEventListener('touchmove', mousemove, {
          passive: true
        });
        image_container.addEventListener('touchend', mouseleave, {
          passive: true
        });
        image_container.addEventListener('mouseenter', mousemove, {
          passive: true
        });
        image_container.addEventListener('mousemove', mousemove, {
          passive: true
        });
        image_container.addEventListener('mouseleave', mouseleave, {
          passive: true
        });
      }

      images.forEach(function (image) {
        window.addEventListener('load', (event) => {
          lazySizes.loader.unveil(image);
        });
      });

    }
    enableSwatches(swatches, image) {
      let swatch_list = swatches.querySelectorAll('.product-card-swatch'),
        org_srcset = image ? image.dataset.srcset : '';
      this.color_index = this.swatches.dataset.index;

      swatch_list.forEach((swatch, index) => {
        window.addEventListener('load', (event) => {
          let image = new Image();
          image.srcset = swatch.dataset.srcset;
          lazySizes.loader.unveil(image);
        });

        swatch.addEventListener('mouseover', () => {
          [].forEach.call(swatch_list, function (el) {
            el.classList.remove('active');
          });
          if (image) {
            if (swatch.dataset.srcset) {
              image.setAttribute('srcset', swatch.dataset.srcset);
            } else {
              image.setAttribute('srcset', org_srcset);
            }
          }
          if (this.size_options) {
            this.current_options[this.color_index] = swatch.querySelector('span').innerText;
            this.updateMasterId();
          }
          swatch.classList.add('active');
        });
        swatch.addEventListener('click', function (evt) {
          window.location.href = this.dataset.href;
          evt.preventDefault();
        });
      });
    }
    enableQuickAdd() {
      this.quick_add.addEventListener('click', this.quickAdd.bind(this));
    }
    enableSizeOptions() {
      let size_list = this.size_options.querySelectorAll('.product-card-sizes--size'),
        featured_image = this.querySelector('.product-card--featured-image'),
        has_hover = featured_image.classList.contains('thb-hover'),
        size_parent = this.size_options.parentElement;

      this.size_index = this.size_options.dataset.index;

      this.current_options = this.size_options.dataset.options.split(',');

      this.updateMasterId();

      size_parent.addEventListener('mouseenter', () => {
        if (has_hover) {
          featured_image.classList.remove('thb-hover');
        }
      }, {
        passive: true
      });
      size_parent.addEventListener('mouseleave', () => {
        if (has_hover) {
          featured_image.classList.add('thb-hover');
        }
      }, {
        passive: true
      });
      size_list.forEach((size) => {
        size.addEventListener('click', (evt) => {
          evt.preventDefault();

          if (size.classList.contains('is-disabled')) {
            return;
          }
          this.current_options[this.size_index] = size.querySelector('span').innerText;
          this.updateMasterId();

          size.classList.add('loading');
          size.setAttribute('aria-disabled', true);
          const config = {
            method: 'POST',
            headers: {
              'X-Requested-With': 'XMLHttpRequest',
              'Accept': 'application/javascript'
            }
          };
          let formData = new FormData();

          formData.append('id', this.currentVariant.id);
          formData.append('quantity', 1);
          formData.append('sections', this.getSectionsToRender().map((section) => section.section));
          formData.append('sections_url', window.location.pathname);

          config.body = formData;

          fetch(`${theme.routes.cart_add_url}`, config)
            .then((response) => response.json())
            .then((response) => {
              if (response.status) {
                return;
              }
              this.renderContents(response);

              dispatchCustomEvent('cart:item-added', {
                product: response.hasOwnProperty('items') ? response.items[0] : response
              });
            })
            .catch((e) => {
              console.error(e);
            })
            .finally(() => {
              size.classList.remove('loading');
              size.removeAttribute('aria-disabled');
            });
        });
      });
    }
    updateMasterId() {
      this.currentVariant = this.getVariantData().find((variant) => {
        return !variant.options.map((option, index) => {
          return this.current_options[index] === option;
        }).includes(false);
      });
      setTimeout(() => {
        this.setDisabled();
      }, 100);
    }
    getVariantData() {
      this.variantData = this.variantData || JSON.parse(this.querySelector('[type="application/json"]').textContent);
      return this.variantData;
    }
    setDisabled() {
      const variant_data = this.getVariantData();

      if (variant_data) {

        if (this.currentVariant) {
          const selected_options = this.currentVariant.options.map((value, index) => {
            return {
              value,
              index: `option${index + 1}`
            };
          });

          const available_options = this.createAvailableOptionsTree(variant_data, selected_options);

          const fieldset_options = Object.values(available_options)[this.size_index];
          if (fieldset_options) {
            if (this.size_options.querySelectorAll('.product-card-sizes--size').length) {
              this.size_options.querySelectorAll('.product-card-sizes--size').forEach((input, input_i) => {
                input.classList.toggle('is-disabled', fieldset_options[input_i].isUnavailable);
              });
            }
          }
        } else {
          if (this.size_options.querySelectorAll('.product-card-sizes--size').length) {
            this.size_options.querySelectorAll('.product-card-sizes--size').forEach((input, input_i) => {
              input.classList.add('is-disabled');
            });
          }
        }

      }
      return true;
    }
    createAvailableOptionsTree(variant_data, selected_options) {
      // Reduce variant array into option availability tree
      return variant_data.reduce((options, variant) => {

        // Check each option group (e.g. option1, option2, option3) of the variant
        Object.keys(options).forEach(index => {

          if (variant[index] === null) return;

          let entry = options[index].find(option => option.value === variant[index]);

          if (typeof entry === 'undefined') {
            // If option has yet to be added to the options tree, add it
            entry = {
              value: variant[index],
              isUnavailable: true
            };
            options[index].push(entry);
          }

          // Check how many selected option values match a variant
          const countVariantOptionsThatMatchCurrent = selected_options.reduce((count, {
            value,
            index
          }) => {
            return variant[index] === value ? count + 1 : count;
          }, 0);

          // Only enable an option if an available variant matches all but one current selected value
          if (countVariantOptionsThatMatchCurrent >= selected_options.length - 1) {
            entry.isUnavailable = entry.isUnavailable && variant.available ? false : entry.isUnavailable;
          }

          // Make sure if a variant is unavailable, disable currently selected option
          if ((!this.currentVariant || !this.currentVariant.available) && selected_options.find((option) => option.value === entry.value && index === option.index)) {
            entry.isUnavailable = true;
          }

          // First option is always enabled
          if (index === 'option1') {
            entry.isUnavailable = entry.isUnavailable && variant.available ? false : entry.isUnavailable;
          }
        });

        return options;
      }, {
        option1: [],
        option2: [],
        option3: []
      });
    }
    quickAdd(evt) {
      evt.preventDefault();
      if (this.quick_add.disabled) {
        return;
      }
      const productId = this.quick_add.dataset.productId;
      const minQuantity = parseInt(this.quick_add.dataset.minQuantity || '1', 10);

      if (!productId || Number.isNaN(Number(productId))) {
        return;
      }

      this.quick_add.classList.add('loading');
      this.quick_add.setAttribute('aria-disabled', true);

      const config = {
        method: 'POST',
        headers: {
          'X-Requested-With': 'XMLHttpRequest',
          'Accept': 'application/javascript'
        }
      };

      let formData = new FormData();

      formData.append('id', productId);
      formData.append('quantity', Number.isNaN(minQuantity) || minQuantity < 1 ? 1 : minQuantity);
      formData.append('sections', this.getSectionsToRender().map((section) => section.section));
      formData.append('sections_url', window.location.pathname);

      config.body = formData;

      fetch(`${theme.routes.cart_add_url}`, config)
        .then((response) => response.json())
        .then((response) => {
          if (response.status) {
            console.warn('Quick add failed:', response.description || response.message || response.status);
            return;
          }
          this.renderContents(response);

          dispatchCustomEvent('cart:item-added', {
            product: response.hasOwnProperty('items') ? response.items[0] : response
          });
        })
        .catch((e) => {
          console.error(e);
        })
        .finally(() => {
          this.quick_add.classList.remove('loading');
          this.quick_add.removeAttribute('aria-disabled');
        });

      return false;
    }
    getSectionsToRender() {
      return [{
        id: 'Cart',
        section: 'main-cart',
        selector: '.thb-cart-form'
      },
      {
        id: 'Cart-Drawer',
        section: 'cart-drawer',
        selector: '.cart-drawer'
      },
      {
        id: 'cart-drawer-toggle',
        section: 'cart-bubble',
        selector: '.thb-item-count'
      }];
    }
    renderContents(parsedState) {
      this.getSectionsToRender().forEach((section => {
        const sectionContainer = document.getElementById(section.id);
        const sectionHtml = parsedState?.sections?.[section.section];

        if (!sectionContainer || !sectionHtml) {
          return;
        }
        const elementToReplace = sectionContainer.querySelector(section.selector) || sectionContainer;
        const innerHtml = this.getSectionInnerHTML(sectionHtml, section.selector);

        if (innerHtml === null) {
          return;
        }

        elementToReplace.innerHTML = innerHtml;

        if (section.id === 'Cart-Drawer') {
          document.getElementById('Cart-Drawer')?.notesToggle();
          document.getElementById('Cart-Drawer')?.removeProductEvent();
        }

        if (section.id === 'Cart' && typeof Cart !== 'undefined') {
          new Cart().renderContents(parsedState);
        }
      }));


      if (document.getElementById('Cart-Drawer')) {
        document.getElementById('Cart-Drawer').classList.add('active');
        document.body.classList.add('open-cart');
        document.body.classList.add('open-cc');
        if (document.getElementById('Cart-Drawer').querySelector('.product-recommendations--full')) {
          document.getElementById('Cart-Drawer').querySelector('.product-recommendations--full').classList.add('active');
        }
        dispatchCustomEvent('cart-drawer:open');
      }
    }
    getSectionInnerHTML(html, selector = '.shopify-section') {
      const parsed = new DOMParser()
        .parseFromString(html, 'text/html')
        .querySelector(selector);

      return parsed ? parsed.innerHTML : null;
    }
  }
  customElements.define('product-card', ProductCard);
}


/**
 *  @class
 *  @function PanelClose
 */
if (!customElements.get('side-panel-close')) {
  class PanelClose extends HTMLElement {
    constructor() {
      super();
    }
    connectedCallback() {
      this.cc = document.querySelector('.click-capture');

      this.onClick = (e) => {
        let panel = document.querySelectorAll('.side-panel.active');
        if (panel.length) {
          this.close_panel(e, panel[0]);
        }
      };
      // Add functionality to buttons
      this.addEventListener('click', this.onClick.bind(this));
      document.addEventListener('panel:close', this.onClick.bind(this));
      if (!this.cc.hasAttribute('initialized')) {
        this.cc.addEventListener('click', this.onClick.bind(this));
        this.cc.setAttribute('initialized', '');
      }

    }
    close_panel(e, panel) {
      if (e) {
        e.preventDefault();
      }
      if (!panel) {
        panel = e?.target.closest('.side-panel.active');

        if (!panel) {
          return;
        }
      }
      if (panel.classList.contains('product-drawer') || document.body.classList.contains('open-quick-view')) {
        this.close_quick_view();
      } else if (panel.classList.contains('cart-drawer')) {
        if (panel.querySelector('.product-recommendations--full')) {
          if (!document.body.classList.contains('open-quick-view')) {
            panel.querySelector('.product-recommendations--full').classList.remove('active');
          }
        }
        if (window.innerWidth < 1069) {
          if (!document.body.classList.contains('open-quick-view')) {
            panel.classList.remove('active');
            document.body.classList.remove('open-cc');
            document.body.classList.remove('open-cart');
          } else {
            this.close_quick_view();
          }
        } else {
          if (panel.querySelector('.product-recommendations--full')) {
            if (!document.body.classList.contains('open-quick-view')) {
              setTimeout(() => {
                panel.classList.remove('active');
                document.body.classList.remove('open-cc');
                document.body.classList.remove('open-cart');
              }, 500);
            } else {
              this.close_quick_view();
            }
          } else {
            panel.classList.remove('active');
            document.body.classList.remove('open-cc');
            document.body.classList.remove('open-cart');
          }
        }
      } else {
        panel.classList.remove('active');
        document.body.classList.remove('open-cc');
      }
    }
    close_quick_view() {
      let panel = document.getElementById('Product-Drawer');

      if (panel.querySelector('.product-quick-images--container')) {
        panel.querySelector('.product-quick-images--container').classList.remove('active');
      }
      if (window.innerWidth < 1069) {
        panel.classList.remove('active');
        if (!document.body.classList.contains('open-cart') || !document.body.classList.contains('open-quick-view')) {
          document.body.classList.remove('open-cc');
        }
        document.body.classList.remove('open-quick-view');
      } else {
        if (panel.querySelector('.product-quick-images--container')) {
          setTimeout(() => {
            panel.classList.remove('active');
            if (!document.body.classList.contains('open-cart') || !document.body.classList.contains('open-quick-view')) {
              document.body.classList.remove('open-cc');
            }
            document.body.classList.remove('open-quick-view');
            panel.querySelector('#Product-Drawer-Content').innerHTML = '';
          }, 500);
        }
      }
    }
  }
  customElements.define('side-panel-close', PanelClose);

  document.addEventListener('keyup', (e) => {
    if (e.code) {
      if (e.code.toUpperCase() === 'ESCAPE') {
        dispatchCustomEvent('panel:close');
      }
    }
  });
}
/**
 *  @class
 *  @function CartDrawer
 */
if (!customElements.get('cart-drawer')) {
  class CartDrawer extends HTMLElement {

    constructor() {
      super();
    }

    connectedCallback() {
      let button = document.getElementById('cart-drawer-toggle');

      // Add functionality to buttons
      button.addEventListener('click', (e) => {
        e.preventDefault();
        document.body.classList.add('open-cc');
        document.body.classList.add('open-cart');
        this.classList.add('active');
        this.focus();
        setTimeout(() => {
          this.querySelector('.product-recommendations--full')?.classList.add('active');
        });
        dispatchCustomEvent('cart-drawer:open');
      });

      this.debouncedOnChange = debounce((event) => {
        this.onChange(event);
      }, 300);

      document.addEventListener('cart:refresh', (event) => {
        this.refresh();
      });

      this.addEventListener('change', this.debouncedOnChange.bind(this));

      this.notesToggle();
      this.removeProductEvent();
    }
    onChange(event) {
      if (event.target.classList.contains('qty')) {
        this.updateQuantity(event.target.dataset.index, event.target.value);
      }
    }
    removeProductEvent() {
      let removes = this.querySelectorAll('.remove');

      removes.forEach((remove) => {
        remove.addEventListener('click', (event) => {
          this.updateQuantity(event.target.dataset.index, '0');

          event.preventDefault();
        });
      });
    }
    getSectionsToRender() {
      return [{
        id: 'Cart-Drawer',
        section: 'cart-drawer',
        selector: '.cart-drawer'
      },
      {
        id: 'cart-drawer-toggle',
        section: 'cart-bubble',
        selector: '.thb-item-count'
      }];
    }
    getSectionInnerHTML(html, selector) {
      return new DOMParser()
        .parseFromString(html, 'text/html')
        .querySelector(selector).innerHTML;
    }
    notesToggle() {
      const notes_toggle = document.getElementById('order-note-toggle');

      if (!notes_toggle) {
        return;
      }

      notes_toggle.addEventListener('click', (event) => {
        notes_toggle.nextElementSibling.classList.add('active');
      });
      notes_toggle.nextElementSibling.querySelectorAll('.button, .order-note-toggle__content-overlay').forEach((el) => {
        el.addEventListener('click', (event) => {
          notes_toggle.nextElementSibling.classList.remove('active');
          this.saveNotes();
        });
      });
    }
    saveNotes() {
      fetch(`${theme.routes.cart_update_url}.js`, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
          'Accept': `application/json`
        },
        body: JSON.stringify({
          'note': document.getElementById('mini-cart__notes').value
        })
      });
    }
    updateQuantity(line, quantity) {
      this.querySelector(`#CartDrawerItem-${line}`)?.classList.add('thb-loading');
      const body = JSON.stringify({
        line,
        quantity,
        sections: this.getSectionsToRender().map((section) => section.section),
        sections_url: window.location.pathname
      });

      dispatchCustomEvent('line-item:change:start', {
        quantity: quantity
      });
      this.querySelector('.product-recommendations--full')?.classList.remove('active');

      fetch(`${theme.routes.cart_change_url}`, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
          'Accept': `application/json`
        },
        ...{
          body
        }
      })
        .then((response) => {
          return response.text();
        })
        .then((state) => {
          const parsedState = JSON.parse(state);

          this.getSectionsToRender().forEach((section => {
            const elementToReplace = document.getElementById(section.id).querySelector(section.selector) || document.getElementById(section.id);

            if (parsedState.sections) {
              elementToReplace.innerHTML = this.getSectionInnerHTML(parsedState.sections[section.section], section.selector);
            }
          }));

          this.removeProductEvent();
          this.notesToggle();
          dispatchCustomEvent('line-item:change:end', {
            quantity: quantity,
            cart: parsedState
          });

          this.querySelector(`#CartDrawerItem-${line}`)?.classList.remove('thb-loading');
        });
    }
    refresh() {
      this.querySelector('.product-recommendations--full')?.classList.remove('active');
      let sections = 'cart-drawer,cart-bubble';
      fetch(`${window.location.pathname}?sections=${sections}`)
        .then((response) => {
          return response.text();
        })
        .then((state) => {
          const parsedState = JSON.parse(state);

          this.getSectionsToRender().forEach((section => {
            const elementToReplace = document.getElementById(section.id).querySelector(section.selector) || document.getElementById(section.id);

            elementToReplace.innerHTML = this.getSectionInnerHTML(parsedState[section.section], section.selector);
          }));

          this.removeProductEvent();
          this.notesToggle();
        });
    }
  }
  customElements.define('cart-drawer', CartDrawer);
}

/**
 *  @class
 *  @function SelectWidth
 */
class SelectWidth {
  constructor() {
    let _this = this;
    // resize on initial load
    window.addEventListener('load', () => {
      document.querySelectorAll('.resize-select').forEach(_this.resizeSelect);
    });

    // delegated listener on change
    document.body.addEventListener('change', (e) => {
      if (e.target.matches('.resize-select') && e.target.offsetParent !== null) {
        _this.resizeSelect(e.target);
      }
    });
    window.addEventListener('resize.resize-select', function () {
      document.querySelectorAll('.resize-select').forEach(_this.resizeSelect);
    });
  }

  resizeSelect(sel) {
    let tempOption = document.createElement('option');
    tempOption.textContent = sel.selectedOptions[0].textContent;

    let tempSelect = document.createElement('select'),
      offset = 13;
    tempSelect.style.visibility = 'hidden';
    tempSelect.style.position = 'fixed';
    tempSelect.appendChild(tempOption);
    if (sel.classList.contains('thb-language-code') || sel.classList.contains('thb-currency-code') || sel.classList.contains('facet-filters__sort')) {
      offset = 2;
    }
    sel.after(tempSelect);
    if (tempSelect.clientWidth > 0) {
      sel.style.width = `${+tempSelect.clientWidth + offset}px`;
    }
    tempSelect.remove();
  }
}

if (typeof SelectWidth !== 'undefined') {
  new SelectWidth();
}

/**
 *  @class
 *  @function FooterMenuToggle
 */
class FooterMenuToggle {
  constructor() {
    let _this = this;
    // resize on initial load
    document.querySelectorAll('.thb-widget-title.collapsible').forEach((button) => {
      button.addEventListener('click', (e) => {
        button.classList.toggle('active');
      });
    });
  }
}

/**
 *  @class
 *  @function QuickView
 */
if (!customElements.get('quick-view')) {
  class QuickView extends HTMLElement {
    constructor() {
      super();
    }
    connectedCallback() {
      this.drawer = document.getElementById('Product-Drawer');
      this.body = document.body;

      this.addEventListener('click', this.setupEventListener.bind(this));

    }
    setupEventListener(e) {
      e.preventDefault();
      let productHandle = this.dataset.productHandle,
        href = `${theme.routes.root_url}/products/${productHandle}?view=quick-view`;

      // remove double `/` in case shop might have /en or language in URL
      href = href.replace('//', '/');
      if (!href || !productHandle) {
        return;
      }
      if (this.classList.contains('loading')) {
        return;
      }
      this.classList.add('loading');
      fetch(href, {
        method: 'GET'
      })
        .then((response) => {
          this.classList.remove('loading');
          return response.text();
        })
        .then(text => {
          const sectionInnerHTML = new DOMParser()
            .parseFromString(text, 'text/html')
            .querySelector('#Product-Drawer-Content').innerHTML;

          this.renderQuickview(sectionInnerHTML, href, productHandle);

        });
    }
    renderQuickview(sectionInnerHTML, href, productHandle) {
      if (sectionInnerHTML) {

        this.drawer.querySelector('#Product-Drawer-Content').innerHTML = sectionInnerHTML;

        let js_files = this.drawer.querySelector('#Product-Drawer-Content').querySelectorAll('script');

        if (js_files.length > 0) {
          var head = document.getElementsByTagName('head')[0];
          js_files.forEach((js_file, i) => {
            let script = document.createElement('script');
            script.src = js_file.src;
            head.appendChild(script);
          });
        }

        setTimeout(() => {
          if (Shopify && Shopify.PaymentButton) {
            Shopify.PaymentButton.init();
          }
          if (window.ProductModel) {
            window.ProductModel.loadShopifyXR();
          }
        }, 300);

        this.body.classList.add('open-cc');
        this.body.classList.add('open-quick-view');
        this.drawer.classList.add('active');

        this.drawer.querySelector('.side-panel-close').focus();

        setTimeout(() => {
          this.drawer.querySelector('.product-quick-images--container').classList.add('active');
        });
        dispatchCustomEvent('quick-view:open', {
          productUrl: href,
          productHandle: productHandle
        });
        addIdToRecentlyViewed(productHandle);
      }
    }
  }
  customElements.define('quick-view', QuickView);
}

/**
 *  @class
 *  @function SidePanelContentTabs
 */
if (!customElements.get('side-panel-content-tabs')) {
  class SidePanelContentTabs extends HTMLElement {
    constructor() {
      super();
      this.buttons = this.querySelectorAll('button');
      this.panels = this.parentElement.querySelectorAll('.side-panel-content--tab-panel');
    }
    connectedCallback() {
      this.setupButtonObservers();
    }
    disconnectedCallback() {

    }
    setupButtonObservers() {
      this.buttons.forEach((item, i) => {
        item.addEventListener('click', (e) => {
          this.toggleActiveClass(i);
        });
      });
    }
    toggleActiveClass(i) {
      this.buttons.forEach((button) => {
        button.classList.remove('tab-active');
      });
      this.buttons[i].classList.add('tab-active');

      this.panels.forEach((panel) => {
        panel.classList.remove('tab-active');
      });
      this.panels[i].classList.add('tab-active');
    }
  }

  customElements.define('side-panel-content-tabs', SidePanelContentTabs);
}

/**
 *  @class
 *  @function CollapsibleRow
 */
if (!customElements.get('collapsible-row')) {
  // https://css-tricks.com/how-to-animate-the-details-element/
  class CollapsibleRow extends HTMLElement {
    constructor() {
      super();

      this.details = this.querySelector('details');
      this.summary = this.querySelector('summary');
      this.content = this.querySelector('.collapsible__content');

      // Store the animation object (so we can cancel it if needed)
      this.animation = null;
      // Store if the element is closing
      this.isClosing = false;
      // Store if the element is expanding
      this.isExpanding = false;
    }
    connectedCallback() {
      this.setListeners();
    }
    setListeners() {
      this.querySelector('summary').addEventListener('click', (e) => this.onClick(e));
    }
    instantClose() {
      this.tl.timeScale(10).reverse();
    }
    animateClose() {
      this.tl.timeScale(3).reverse();
    }
    animateOpen() {
      this.tl.timeScale(1).play();
    }
    onClick(e) {
      // Stop default behaviour from the browser
      e.preventDefault();
      // Add an overflow on the <details> to avoid content overflowing
      this.details.style.overflow = 'hidden';
      // Check if the element is being closed or is already closed
      if (this.isClosing || !this.details.open) {
        this.open();
        // Check if the element is being openned or is already open
      } else if (this.isExpanding || this.details.open) {
        this.shrink();
      }
    }
    shrink() {
      // Set the element as "being closed"
      this.isClosing = true;

      // Store the current height of the element
      const startHeight = `${this.details.offsetHeight}px`;
      // Calculate the height of the summary
      const endHeight = `${this.summary.offsetHeight}px`;

      // If there is already an animation running
      if (this.animation) {
        // Cancel the current animation
        this.animation.cancel();
      }

      // Start a WAAPI animation
      this.animation = this.details.animate({
        // Set the keyframes from the startHeight to endHeight
        height: [startHeight, endHeight]
      }, {
        duration: 250,
        easing: 'ease'
      });

      // When the animation is complete, call onAnimationFinish()
      this.animation.onfinish = () => this.onAnimationFinish(false);
      // If the animation is cancelled, isClosing variable is set to false
      this.animation.oncancel = () => this.isClosing = false;
    }

    open() {
      // Apply a fixed height on the element
      this.details.style.height = `${this.details.offsetHeight}px`;
      // Force the [open] attribute on the details element
      this.details.open = true;
      // Wait for the next frame to call the expand function
      window.requestAnimationFrame(() => this.expand());
    }

    expand() {
      // Set the element as "being expanding"
      this.isExpanding = true;
      // Get the current fixed height of the element
      const startHeight = `${this.details.offsetHeight}px`;
      // Calculate the open height of the element (summary height + content height)
      const endHeight = `${this.summary.offsetHeight + this.content.offsetHeight}px`;

      // If there is already an animation running
      if (this.animation) {
        // Cancel the current animation
        this.animation.cancel();
      }

      // Start a WAAPI animation
      this.animation = this.details.animate({
        // Set the keyframes from the startHeight to endHeight
        height: [startHeight, endHeight]
      }, {
        duration: 400,
        easing: 'ease-out'
      });
      // When the animation is complete, call onAnimationFinish()
      this.animation.onfinish = () => this.onAnimationFinish(true);
      // If the animation is cancelled, isExpanding variable is set to false
      this.animation.oncancel = () => this.isExpanding = false;
    }

    onAnimationFinish(open) {
      // Set the open attribute based on the parameter
      this.details.open = open;
      // Clear the stored animation
      this.animation = null;
      // Reset isClosing & isExpanding
      this.isClosing = false;
      this.isExpanding = false;
      // Remove the overflow hidden and the fixed height
      this.details.style.height = this.details.style.overflow = '';
    }
  }
  customElements.define('collapsible-row', CollapsibleRow);
}

/**
 *  @function addIdToRecentlyViewed
 */
function addIdToRecentlyViewed(handle) {

  if (!handle) {
    let product = document.querySelector('.thb-product-detail');

    if (product) {
      handle = product.dataset.handle;
    }
  }
  if (!handle) {
    return;
  }
  if (window.localStorage) {
    let recentIds = window.localStorage.getItem('recently-viewed');
    if (recentIds != 'undefined' && recentIds != null) {
      window.recentlyViewedIds = JSON.parse(recentIds);
    }
  }
  // Remove current product if already in recently viewed array
  var i = window.recentlyViewedIds.indexOf(handle);

  if (i > -1) {
    window.recentlyViewedIds.splice(i, 1);
  }

  // Add id to array
  window.recentlyViewedIds.unshift(handle);

  if (window.localStorage) {
    window.localStorage.setItem('recently-viewed', JSON.stringify(window.recentlyViewedIds));
  }
}

document.addEventListener('DOMContentLoaded', () => {
  if (typeof FooterMenuToggle !== 'undefined') {
    new FooterMenuToggle();
  }
});

// bundle js

  window.addEventListener('load', function () {
    // only load the video on desktop
    if(window.innerWidth > 789 ){
      document.querySelectorAll('.lazy-video').forEach(function (video) {
        const src = video.parentElement.getAttribute('data-video-src');
        if (src) {
          const source = document.createElement('source');
          source.src = src;
          source.type = 'video/mp4';
          video.appendChild(source);
          video.load();
          video.play().catch(() => {}); // optional, in case autoplay is needed
        }
      });
    }
      
  });
    document.addEventListener("DOMContentLoaded", function () {
      initBundleDeals();
    });



    function initBundleDeals() {
      // const discounts = [0.15, 0.2, 0.25, 0.3, 0.35, 0.4, 0.45];
  // 用 theme 的货币格式显示价格
  const formatMoney = (amount) =>
        window.theme.settings.money_with_currency_format.replace(/{{\s*amount\s*}}/, amount.toFixed(2));

  const parseMoneyTextToNumber = (value) => parseFloat(String(value || '').replace(/[^\d.-]+/g, '')) || 0;

  const getSelectedVariantPrices = (selectElem) => {
    const selectedOption = (selectElem?.selectedIndex >= 0 && selectElem.options[selectElem.selectedIndex])
      || selectElem?.querySelector('option:checked');
    if (!selectedOption) {
      return { price: 0, originalPrice: 0 };
    }

    const priceCentsAttr = selectedOption.getAttribute('data-price-cents');
    const originalPriceCentsAttr = selectedOption.getAttribute('data-original-price-cents');

    const priceCents = (priceCentsAttr !== null && priceCentsAttr !== '') ? Number(priceCentsAttr) : NaN;
    const originalPriceCents = (originalPriceCentsAttr !== null && originalPriceCentsAttr !== '') ? Number(originalPriceCentsAttr) : NaN;

    const price = Number.isFinite(priceCents)
      ? priceCents / 100
      : parseMoneyTextToNumber(selectedOption.getAttribute('data-price'));
    const originalPrice = Number.isFinite(originalPriceCents)
      ? originalPriceCents / 100
      : parseMoneyTextToNumber(selectedOption.getAttribute('data-original_price'));

    return { price, originalPrice };
  };

      function updateAddToCartHolderPrice(discountedPrice, originalPrice) {
        document.querySelectorAll(".add_to_cart_holder .add_to_cart_holder__price .price").forEach((priceWrapper) => {
          const discountedAmountElement = priceWrapper.querySelector("ins .amount") || priceWrapper.querySelector(".amount.discounted");
          const compareAmountElement = priceWrapper.querySelector("del .amount");
          const comparePriceElement = compareAmountElement ? compareAmountElement.closest("del") : null;

          if (discountedAmountElement && !isNaN(discountedPrice)) {
            discountedAmountElement.textContent = formatMoney(discountedPrice);
          }

          if (comparePriceElement) {
            const hasDiscount = !isNaN(originalPrice) && originalPrice > discountedPrice && originalPrice > 0;
            const compareBreak = comparePriceElement.nextElementSibling;

            if (hasDiscount) {
              compareAmountElement.textContent = formatMoney(originalPrice);
              comparePriceElement.style.removeProperty("display");
              if (compareBreak && compareBreak.tagName === "BR") {
                compareBreak.style.removeProperty("display");
              }
            } else {
              comparePriceElement.style.display = "none";
              if (compareBreak && compareBreak.tagName === "BR") {
                compareBreak.style.display = "none";
              }
            }

            if (discountedAmountElement && originalPrice > discountedPrice) {
              discountedAmountElement.classList.toggle("discounted", hasDiscount);
            }
          }
        });
      }


  // Toggle selection state and update visuals/prices when a bundle checkbox changes
  function handleBundleSelectionChange(checkbox) {
    const parentDiv = checkbox.closest(".bundle-deals__product");
    const index = parseInt(checkbox.id.split("-")[1], 10);
    const mediaItem = document.querySelector(`.bundle-deals__media-item:nth-child(${index + 1})`);

    if (checkbox.checked) {
      parentDiv.classList.add("bundle-deals__product--selected");
      mediaItem?.classList.remove("bundle-deals__media-item--disabled");
    } else {
      parentDiv.classList.remove("bundle-deals__product--selected");
      mediaItem?.classList.add("bundle-deals__media-item--disabled");
    }

    updateTotalBundlePrices();
  }

  // Update price display for a polishing pad bundle product based on selected variants and quantities
  function updatePolishingPadPrice(element) {

    const parentDiv = element.closest(".bundle-deals__product") || element.closest(".bundle-item_wrapper");
    let totalQuantity = 0;
    let totalOriginalPrice = 0;
    let rawOriginalPrice = 0;

    parentDiv.querySelectorAll(".quantity-break__variant-select").forEach((selectElem) => {
      const selectedOption = selectElem.querySelector("option:checked");
      if (!selectedOption) return;

      rawOriginalPrice = selectedOption.getAttribute("data-original_price")?.trim().replace("$", "") || "0";
      const quantityInput = selectElem.closest(".quantity-break__selector-item").querySelector('[name="quantity"]');
      const quantity = quantityInput ? Number(quantityInput.value) : 0;

      const selectorItem = selectElem.closest(".quantity-break__selector-item");
      if (quantity === 0) {
        selectorItem.classList.add("not_added");
        selectorItem.classList.remove("added");
      } else {
        selectorItem.classList.remove("not_added");
        selectorItem.classList.add("added");
      }

      totalQuantity += quantity;
      totalOriginalPrice += Number(rawOriginalPrice) * quantity;
    });
    let discountIndex = totalQuantity - 1;
    if (discountIndex < 0) discountIndex = 0;

    let max_discount = parentDiv.querySelectorAll(".quantity-break__variant-select").length;

    if (discountIndex >= max_discount) discountIndex = max_discount - 1;
    const discountRate = 0.15 + discountIndex * 0.05;
    const discountedPrice = totalOriginalPrice * (1 - discountRate);
    const rawDiscountedPrice = rawOriginalPrice * (1 - discountRate);
    const savePercentage = parseInt(discountRate * 100);

    // update the product price 
    if(element.closest(".bundle-item_wrapper")) {
      const label_container = element.closest("label");
      const input_checked = label_container.previousElementSibling.checked;
      if(input_checked){
        document.querySelector('.product-price-container .amount.discounted').innerText = formatMoney(rawDiscountedPrice);
        if(rawOriginalPrice > rawDiscountedPrice){
          document.querySelector('.product-price-container del .amount').innerText = formatMoney(Number(rawOriginalPrice));
        }
        updateAddToCartHolderPrice(Number(rawDiscountedPrice), Number(rawOriginalPrice));
      }
    }

    const addedInput = parentDiv.querySelector(".added input");
    if (addedInput) {
      if (totalQuantity === 1) {
        addedInput.min = 1;
        addedInput.classList.add("min_1");
      } else if (addedInput.classList.contains("min_1")) {
        addedInput.min = 0;
        addedInput.classList.remove("min_1");
      }
    }

    parentDiv.querySelector(".bundle-item_left_top span").innerText = `${savePercentage}% off`;
    parentDiv.querySelector(".discounted.amount").innerText = formatMoney(discountedPrice);
    parentDiv.querySelector(".original_price .amount").innerText = formatMoney(totalOriginalPrice);
    parentDiv.querySelector(".bundle-item_left_bottom").innerHTML = `<span style="opacity:0.8">You save</span> ${formatMoney(totalOriginalPrice - discountedPrice)}`;
  }

  // Update price display for a single bundle product based on selected variants
  function updateSingleBundleProductPrice(element) {
    const parentDiv = element.closest(".bundle-deals__product") || element.closest(".bundle-item_wrapper");
    const allSelects = parentDiv.querySelectorAll("select");

    let totalPrice = 0;
    let totalOriginalPrice = 0;

    allSelects.forEach((sel) => {
      const { price, originalPrice } = getSelectedVariantPrices(sel);
      totalPrice += price;
      totalOriginalPrice += originalPrice;
    });

    parentDiv.querySelector(".discounted.amount").innerText = formatMoney(totalPrice);
    if(totalOriginalPrice > totalPrice){
      parentDiv.querySelector(".original_price .amount").innerText = formatMoney(totalOriginalPrice);
    if(parentDiv.querySelector(".bundle-item_left_bottom")){
      parentDiv.querySelector(".bundle-item_left_bottom").innerHTML = `<span style="opacity:0.8">You save</span> ${formatMoney(totalOriginalPrice - totalPrice)}`;
    }
    }


    if (element.closest(".bundle-item_wrapper")) {
      const labelContainer = element.closest("label");
      const inputChecked = labelContainer?.previousElementSibling?.checked;
      if (inputChecked) {
        updateAddToCartHolderPrice(totalPrice, totalOriginalPrice);
      }
    }

    updateTotalBundlePrices();
  }

  // Calculate and update the overall total prices of all selected bundles
  function updateTotalBundlePrices() {
    let totalDiscounted = 0;
    let totalOriginal = 0;

    document.querySelectorAll(".bundle-deals__product--selected").forEach((product) => {
      const selects = product.querySelectorAll('.quantity-break__variant-select');

      if (selects.length) {
        selects.forEach((sel) => {
          const { price, originalPrice } = getSelectedVariantPrices(sel);
          totalDiscounted += price;
          totalOriginal += originalPrice;
        });
        return;
      }

      const discountedElement = product.querySelector('.amount.discounted');
      const originalElement = product.querySelector('.original_price .amount');
      totalDiscounted += parseMoneyTextToNumber(discountedElement?.textContent || 0);
      totalOriginal += parseMoneyTextToNumber(originalElement?.textContent || 0);
    });

    const discountedTotalElement = document.querySelector(".bundle-deals__total-price");
    if (discountedTotalElement) {
      discountedTotalElement.textContent = formatMoney(totalDiscounted);
    }
    const originalTotalElement = document.querySelector(".bundle-deals__total-compare-price");
    if (originalTotalElement && totalOriginal > totalDiscounted) {
      originalTotalElement.textContent = formatMoney(totalOriginal);
    }

  }

  // Event listeners
  document.querySelectorAll(".bundle-deals__checkbox").forEach((checkbox) => {
    checkbox.addEventListener("change", () => handleBundleSelectionChange(checkbox));
  });

document.addEventListener("change", (e) => {

  const select = e.target.closest(".quantity-break__variant-select");

  if (!select) return;

  if (select.closest(".polishing_pads")) {
    debugger;
    updatePolishingPadPrice(select);
        var select_value = select.options[select.selectedIndex].text;
        const selected_input = document.querySelector(
        `.thb-product-detail variant-selects .product-variant_wrapper  input[value="${select_value}"]`
      );
        if(select_value && selected_input){
          selected_input.click();
        }
  } else {

    updateSingleBundleProductPrice(select);

  }

});

  document.querySelectorAll('.quantity-break__selector-item [name="quantity"]').forEach((input) => {
    input.addEventListener("change", () => {
      if (input.closest(".polishing_pads")) {
        updatePolishingPadPrice(input);
      }
    });
  });

  document.querySelectorAll('.bundle-wrapper > [name="quantity"], .custom_bundle-wrapper > [name="quantity"]').forEach((input) => {
    input.addEventListener("change", () => {
      if (input.closest(".polishing_pads")) {
        const label_container = input.nextElementSibling;
        const element = label_container.querySelector('select');
        updatePolishingPadPrice(element);

        // update the variant options
        var container_label = element.closest('label.quantity-break');
        if(container_label){
          var selected_inches = container_label.getAttribute('data-quantity');
        }
        if(selected_inches && document.querySelector(`.thb-product-detail .product-variant_wrapper input[value="${selected_inches}"]`)){
          document.querySelector(`.thb-product-detail .product-variant_wrapper input[value="${selected_inches}"]`).click();
        }
      }else{
        const labelContainer = input.nextElementSibling;
        const element = labelContainer?.querySelector('select');
        if (element) {
          updateSingleBundleProductPrice(element);
        }
      }
    });
  });

  // Initial update
  document.querySelectorAll(".quantity-break__variant-select").forEach((select) => {
    if (select.closest(".polishing_pads")) {
      updatePolishingPadPrice(select);


    } else {
      updateSingleBundleProductPrice(select);
    }
  });

  updateTotalBundlePrices();
}


document.addEventListener('DOMContentLoaded', () => {
  const thresholdUSD = 50;
  if (window.Shopify && Shopify.currency && Shopify.currency.rate) {
    const converted = (thresholdUSD * Shopify.currency.rate).toFixed(2);
    let symbol = '';
    if(window.Shopify.currency.symbo){
       symbol = Shopify.currency.active === 'USD' ? '$' : window.Shopify.currency.symbol;
    }
    document.querySelectorAll('.cart-mini-order').forEach(item=>{
      item.innerText =
      `Enjoy free shipping when you spend ${symbol}${converted} ${Shopify.currency.active} or more.`;
    })
  }
});
// annoucement copy button
var copyButton = document.querySelectorAll(".announcement-bar [href='#copy']");
copyButton.forEach(function(button) {
  button.addEventListener("click", function(event) {
    event.preventDefault();
   // Copy the text inside the text field
    navigator.clipboard.writeText('WELCOME10');
    // Alert the copied text
    alert("Copied the promo code: " + 'WELCOME10');
  })
});